import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { VariantGroup } from './useVariantGroups';

export const getGroupNavigationVariant = (
  group: VariantGroup,
  currentVariant: VariantGroup['variants'][number],
  getGroupingKey: (
    variant: GetCatalogProductViewQuery['productDetailByCatalogMasterId']['variants'][number]
  ) => string
) => {
  const isCurrentVariantInSelectedGroup =
    getGroupingKey(currentVariant) === group.key;

  if (isCurrentVariantInSelectedGroup) {
    return currentVariant;
  }

  return (
    group.variants.find((v) => v.variantType === currentVariant.variantType) ??
    group.variants[0]
  );
};

export const sortGroups = (groups: VariantGroup[]) => {
  return [...groups].sort((a, b) => {
    const isNumber = !Number.isNaN(Number(a.key));

    if (isNumber) {
      return Number(a.key) - Number(b.key);
    }

    return a.name.localeCompare(b.name);
  });
};
